import { AppLog } from "services";
import { toast } from "react-toastify";
import { StatusMsg } from "utils";

interface LogOptions {
  message: string;
  status?: StatusMsg;
  error?: unknown;
}

export const Snackbar = ({ message, status = StatusMsg.info, error }: LogOptions) => {
  const statusToToastMap: Record<string, { toastFunc: (msg: string, options?: any) => void; consoleColor: string }> = {
    [StatusMsg.info.value]: { toastFunc: toast.info, consoleColor: "\x1b[34m" }, // Blue for info
    [StatusMsg.success.value]: {
      toastFunc: toast.success,
      consoleColor: "\x1b[32m",
    }, // Green for success
    [StatusMsg.warning.value]: {
      toastFunc: toast.warn,
      consoleColor: "\x1b[33m",
    }, // Yellow for warning
    [StatusMsg.error.value]: {
      toastFunc: toast.error,
      consoleColor: "\x1b[31m",
    }, // Red for error
  };

  const { toastFunc, consoleColor } = statusToToastMap[status.value] || {
    toastFunc: toast,
    consoleColor: "\x1b[0m",
  };

  // Display the toast notification
  toastFunc(message, {
    className: status.value === StatusMsg.success.value ? "success" : status.value === StatusMsg.error.value ? "danger" : "",
  });

  // Log the message with the appropriate color
  console.log(`${consoleColor} status: ${status.value}, message: ${message} \x1b[0m`);

  // * JK : Update Log with error
  switch (status) {
    case StatusMsg.error:
      AppLog.show({ message: message, status: status, error: error });
      break;
  }
};
